"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableRow = void 0;
var tslib_1 = require("tslib");
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../theme/colors");
var badge_1 = require("../badge");
var checkbox_1 = require("../checkbox");
var flexbox_1 = require("../flexbox");
var icons_1 = require("../icons");
var menu_1 = require("../menu");
var padding_1 = require("../padding");
var popover_menu_1 = require("../popover-menu");
var text_1 = require("../text");
function CategoryLabel(props) {
    var label = props.label, type = props.type;
    if (!type) {
        return (react_1.default.createElement(text_1.Text, { color: "light", nowrap: true }, label));
    }
    return react_1.default.createElement(badge_1.Badge, { type: type }, label);
}
function SelectableRow(props) {
    var categoryLabel = props.categoryLabel, categoryType = props.categoryType, _a = props.dense, dense = _a === void 0 ? false : _a, isSelected = props.isSelected, onClick = props.onClick, overflowActions = props.overflowActions, _b = props.overflowActionOptions, overflowActionOptions = _b === void 0 ? { anchor: 'topRight', targetAnchor: 'bottomRight' } : _b, _c = props.selectType, selectType = _c === void 0 ? 'radio' : _c, subtitle = props.subtitle, title = props.title;
    var className = (0, classnames_1.default)({
        SelectableRow: true,
        isSelected: isSelected,
    });
    function toggle() {
        onClick(!isSelected);
    }
    function onKeyDown(e) {
        if (e.key === ' ') {
            e.preventDefault();
            toggle();
        }
    }
    return (react_1.default.createElement(StyledDiv, { className: className, dense: dense },
        react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "space-between", alignItems: "center" },
            react_1.default.createElement(padding_1.Padding, { y: dense ? 16 : 24, left: dense ? 12 : 16, style: { flexGrow: 1 } },
                react_1.default.createElement("div", { onClick: toggle, onKeyDown: onKeyDown, role: "checkbox", "aria-checked": isSelected, tabIndex: 0 },
                    react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "space-between", alignItems: "center" },
                        react_1.default.createElement(flexbox_1.Flexbox, null,
                            react_1.default.createElement("div", { style: { width: 20 } },
                                selectType === 'radio' && react_1.default.createElement(icons_1.IconRadioButton, { isActive: isSelected }),
                                selectType === 'checkbox' && react_1.default.createElement(checkbox_1.Checkbox, { isActive: isSelected })),
                            react_1.default.createElement(padding_1.Padding, { left: 12 },
                                react_1.default.createElement(text_1.Text, { color: "dark" }, title),
                                subtitle ? (react_1.default.createElement(text_1.Text, { marginTop: 2, color: "light", size: "small" }, subtitle)) : null)),
                        react_1.default.createElement("div", null, categoryLabel ? react_1.default.createElement(CategoryLabel, { label: categoryLabel, type: categoryType }) : null)))),
            react_1.default.createElement(padding_1.Padding, { y: dense ? 16 : 24, x: dense ? 12 : 16 }, overflowActions && (react_1.default.createElement(popover_menu_1.PopoverMenu, { type: "more", options: overflowActionOptions }, function (toggleMenu) { return react_1.default.createElement(menu_1.Menu, { onToggle: toggleMenu, items: overflowActions }); }))))));
}
exports.SelectableRow = SelectableRow;
var StyledDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  border-bottom: ", ";\n  cursor: pointer;\n\n  :focus {\n    background: ", ";\n    outline: none;\n  }\n\n  &.isSelected {\n    background: ", ";\n  }\n"], ["\n  border-bottom: ", ";\n  cursor: pointer;\n\n  :focus {\n    background: ", ";\n    outline: none;\n  }\n\n  &.isSelected {\n    background: ", ";\n  }\n"])), function (_a) {
    var dense = _a.dense;
    return (dense ? '0px' : '1px solid #dbdbdb');
}, colors_1.colors.brand[100], colors_1.colors.brand[100]);
var templateObject_1;
//# sourceMappingURL=index.js.map